import { useDeclarativeText } from '../i18n/declarativeText'

/** Texto estrutural originado em um objeto de configuração (nunca dado livre). */
export function DeclarativeText({ value }: { value: string }) {
  const tt = useDeclarativeText()
  return <>{tt(value)}</>
}
